import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import type {
	PageRestrictionsQuery as Q,
	PageRestrictionsQueryVariables as V,
} from './__types__/PageRestrictionsQuery.ts';
import { ALLOWED_CONTENT_STATUSES } from './constants.ts';
import { PageRestrictionsQuery } from './PageRestrictionsQuery.graphql.ts';

export function preloadPageRestrictionsQuery(contentId: V['contentId'], includeAncestors: boolean) {
	return query<Q, V>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: PageRestrictionsQuery,
		variables: {
			contentId,
			status: ALLOWED_CONTENT_STATUSES,
			includeAncestors,
		},
		// Preloaders are called both on server at initial load AND transition on client-side.
		// On server-side it doesn't matter fetch policy because we only gonna request once.
		// On client-side it must be network-only to get fresh data.
		fetchPolicy: 'network-only',
	});
}
